import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomThankMessageComponent } from './custom-thank-message/custom-thank-message.component';
import { SharedModule } from '@shared/shared.module';
import { RouterModule } from '@angular/router';
import { UrlModule } from '@spartacus/core';

@NgModule({
  declarations: [CustomThankMessageComponent],
  imports: [CommonModule, SharedModule, RouterModule, UrlModule],
})
export class ComponentsModule {}
